import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map, tap } from 'rxjs';
import { ApplicationActions } from './application.actions';
import { BreakpointState } from '@angular/cdk/layout';
import { ApplicationService } from '../../application.service';
import { ToastService } from '@techniek-team/services';
import { GuardsCheckEnd, GuardsCheckStart, Router } from '@angular/router';

@Injectable()
export class ApplicationEffects {
  private readonly actions$: Actions = inject(Actions);
  private readonly toastService: ToastService = inject(ToastService);
  private readonly applicationService: ApplicationService =
    inject(ApplicationService);
  private readonly router: Router = inject(Router);

  public setBreakPoint$ = createEffect(() => {
    return this.applicationService.breakPoint$.pipe(
      map((result: BreakpointState) =>
        ApplicationActions.screenSizeChanged({
          screenSize: this.applicationService.getScreenSize(result),
        }),
      ),
    );
  });

  public showToaster$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(ApplicationActions.showToaster),
        tap((action) => {
          const color: string =
            action.toaster.type === 'success' ? 'success' : 'danger';
          return this.toastService.create(
            action.toaster.message,
            3000,
            color,
            undefined,
            'bottom',
          );
        }),
      );
    },
    { dispatch: false },
  );

  public guardCheckStart$ = createEffect(() => {
    return this.router.events.pipe(
      filter((event) => event instanceof GuardsCheckStart),
      map(() => ApplicationActions.guardsCheckStart()),
    );
  });

  public guardCheckEnd$ = createEffect(() => {
    return this.router.events.pipe(
      filter((event) => event instanceof GuardsCheckEnd),
      map(() => ApplicationActions.guardsCheckEnd()),
    );
  });
}
